import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Datepicker from 'react-datepicker';
import * as moment from 'moment';
import 'moment/locale/de';
import Select2 from 'react-select2-wrapper';

import LoadingOverlay from '../elements/LoadingOverlay';
import connect from "react-redux/es/connect/connect";
import {appDialogAddShiftClose} from "../../actions/appAction";

import ShiftApi from '../../apis/ShiftApi';
import {getSchedule} from "../../actions/scheduleAction";

class AddShiftDialog extends Component {

    state = {
        loading: true,
        availableLocations: [],
        repeatingShift: false,
        startAt: null,
        endAt: null,
        slots: 1,
        overloadable: false,
        importance: 'MIDDLE',
        location: null,
        comment: '',
        errors: {}
    };

    componentWillMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
    }

    componentDidMount() {
        ShiftApi.getAvailableLocations()
            .then((response) => {
                if(response.data.success) {
                    this.setState({
                        availableLocations: response.data.data,
                        loading: false
                    });
                }
            })
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    handleClick = (e) => {
        let node = e.target;
        let found = false;

        // ignore clicks on the component itself
        while (node && node.classList) {
            if (node.classList.contains("modal-content")) {
                found = true;
            }

            node = node.parentNode;
        }
        if (!found) {
            this.props.cancel();
            return true;
        }
        return false;
    };

    handleStartAtChange = (date) => {
        this.setState({startAt: moment(date).format(`${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`)});
        this.setState({endAt: moment(date).add(6, 'hour').format(`${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`)});
    };

    handleEndAtChange = (date) => {
        this.setState({endAt: moment(date).format(`${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`)});
    };

    handleFirstDayChange = (date) => {
        this.setState({firstDay: moment(date).format('DD.MM.YYYY')});
        this.setState({lastDay: moment(date).add(5, 'days').format('DD.MM.YYYY')});
    };

    handleLastDayChange = (date) => {
        this.setState({lastDay: moment(date).format('DD.MM.YYYY')});
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        this.setState({loading: true});
        ShiftApi.addShift(
            this.state.repeatingShift,
            this.state.firstDay,
            this.state.lastDay,
            this.state.startAt,
            this.state.endAt,
            this.state.slots,
            this.state.overloadable,
            this.state.importance,
            this.state.location,
            this.state.comment
        ).then((response) => {
            this.setState({loading: false});
            if(response.data.success) {
                this.props.getSchedule();
                this.props.cancel();
            } else {
                this.setState({errors: response.data.errors});
            }
        });
    };

    changeRepeatingShift = (newValue) => {
        if(newValue !== true) {
            this.setState({
                repeatingShift: false,
                startAt: this.state.startAt ? moment(this.state.startAt, 'HH:mm').format('DD.MM.YYYY HH:mm') : null,
                endAt: this.state.endAt ? moment(this.state.endAt, 'HH:mm').format('DD.MM.YYYY HH:mm') : null,
            });
        } else {
            this.setState({
                repeatingShift: true,
                startAt: this.state.startAt ? moment(this.state.startAt, 'DD.MM.YYYY HH:mm').format('HH:mm') : null,
                endAt: this.state.endAt ? moment(this.state.endAt, 'DD.MM.YYYY HH:mm').format('HH:mm') : null,
            });
        }
    };

    render() {
        const { t } = this.props;
        return (
            <div className="AddShiftDialog modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}} ref={node => { this.node = node; }} onClick={this.handleClick}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button className="close" onClick={this.props.cancel}>
                                <span>x</span>
                            </button>
                            <h4 className="modal-title">
                                {t('addShiftDialog.title')}
                            </h4>
                        </div>
                        <div className={this.state.loading ? 'LoadingOverlayContainer' : ''}>
                            {this.state.loading ? (
                                <LoadingOverlay/>
                            ) : null}
                            <form onSubmit={this.handleFormSubmit}>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="btn-group">
                                                <button type="button"
                                                        className={`btn btn-${!this.state.repeatingShift ? 'primary' : 'default'}`}
                                                        onClick={() => this.changeRepeatingShift(false)}>
                                                    {t('addShift.repeatingShift.no')}
                                                </button>
                                                <button type="button"
                                                        className={`btn btn-${this.state.repeatingShift ? 'primary' : 'default'}`}
                                                        onClick={() => this.changeRepeatingShift(true)}>
                                                    {t('addShift.repeatingShift.yes')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hr-line-dashed"/>
                                    {this.state.repeatingShift ? (
                                        <div className="row m-t">
                                            <div className="col-xs-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.firstDay) ? ' has-error' : '')}>
                                                    <label className="block">{t('addShift.firstDay.label')}</label>
                                                    <Datepicker
                                                        selected={this.state.firstDay ? moment(this.state.firstDay, 'DD.MM.YYYY') : null }
                                                        dateFormat="DD.MM.YYYY" locale={moment.locale('de')}
                                                        className="form-control"
                                                        value={this.state.firstDay}
                                                        onChange={this.handleFirstDayChange}/>

                                                    {(this.state.errors && this.state.errors.firstDay) ? (
                                                        <span className="help-block">
                                                        {t('addShift.firstDay.error.' + this.state.errors.firstDay)}
                                                    </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-xs-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.lastDay) ? ' has-error' : '')}>
                                                    <label className="block">{t('addShift.lastDay.label')}</label>
                                                    <Datepicker
                                                        selected={this.state.lastDay ? moment(this.state.lastDay, 'DD.MM.YYYY') : null }
                                                        dateFormat="DD.MM.YYYY" locale={moment.locale('de')}
                                                        className="form-control"
                                                        value={this.state.lastDay}
                                                        onChange={this.handleLastDayChange}/>

                                                    {(this.state.errors && this.state.errors.lastDay) ? (
                                                        <span className="help-block">
                                                        {t('addShift.lastDay.error.' + this.state.errors.lastDay)}
                                                    </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="row m-t">
                                        <div className="col-xs-6">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.startAt) ? ' has-error' : '')}>
                                                <label className="block">{t('addShift.startAt.label')}</label>
                                                <Datepicker
                                                    selected={this.state.startAt ? moment(this.state.startAt, `${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`) : null }
                                                    dateFormat={`${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`} locale={moment.locale('de')}
                                                    timeFormat="HH:mm"
                                                    className="form-control"
                                                    value={this.state.startAt}
                                                    showTimeSelect
                                                    showTimeSelectOnly={this.state.repeatingShift}
                                                    timeCaption="time"
                                                    onChange={this.handleStartAtChange}/>

                                                {(this.state.errors && this.state.errors.startAt) ? (
                                                    <span className="help-block">
                                                        {t('addShift.startAt.error.' + this.state.errors.startAt)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-xs-6">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.endAt) ? ' has-error' : '')}>
                                                <label className="block">{t('addShift.endAt.label')}</label>
                                                <Datepicker
                                                    selected={this.state.endAt ? moment(this.state.endAt, `${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`) : null }
                                                    dateFormat={`${!this.state.repeatingShift ? 'DD.MM.YYYY ' : ''}HH:mm`} locale={moment.locale('de')}
                                                    timeFormat="HH:mm"
                                                    className="form-control"
                                                    value={this.state.endAt}
                                                    showTimeSelect
                                                    showTimeSelectOnly={this.state.repeatingShift}
                                                    timeCaption="time"
                                                    onChange={this.handleEndAtChange}/>

                                                {(this.state.errors && this.state.errors.endAt) ? (
                                                    <span className="help-block">
                                                        {t('addShift.endAt.error.' + this.state.errors.endAt)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.slots) ? ' has-error' : '')}>
                                                <label>{t('addShift.slots.label')}</label>
                                                <input type="number" className="form-control" name="slots" value={this.state.slots} onChange={(e) => this.setState({slots: e.target.value})}/>

                                                {(this.state.errors && this.state.errors.slots) ? (
                                                    <span className="help-block">
                                                        {t('addShift.slots.error.' + this.state.errors.slots)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.overloadable) ? ' has-error' : '')}>
                                                <label>{t('addShift.overloadable.label')}</label>
                                                <input type="checkbox" className="form-control" name="overloadable" checked={this.state.overloadable} onChange={() => this.setState({overloadable: !this.state.overloadable})}/>

                                                {(this.state.errors && this.state.errors.overloadable) ? (
                                                    <span className="help-block">
                                                        {t('addShift.overloadable.error.' + this.state.errors.overloadable)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-xs-6">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.importance) ? ' has-error' : '')}>
                                                <label>{t('addShift.importance.label')}</label>
                                                <select name="importance" className="form-control" value={this.state.importance} onChange={(e) => this.setState({importance: e.target.value})}>
                                                    {['LOW', 'MEDIUM_LOW', 'MIDDLE', 'MEDIUM_HIGH', 'HIGH'].map((importance, i) => (
                                                        <option value={importance} key={i}>
                                                            {t('addShift.importance.' + importance)}
                                                        </option>
                                                    ))}
                                                </select>

                                                {(this.state.errors && this.state.errors.importance) ? (
                                                    <span className="help-block">
                                                        {t('addShift.importance.error.' + this.state.errors.importance)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.location) ? ' has-error' : '')}>
                                                <label>{t('addShift.location.label')}</label>
                                                <Select2 data={this.state.availableLocations.map((el) => {
                                                    return {
                                                        text: (el.name + (el.name !== el.locationGroupName ? ' (' + el.locationGroupName + ')' : '')), id: el.id
                                                    }
                                                })} value={this.state.location} onChange={(e) => this.setState({location: e.target.value})} name="location"
                                                         options={{placeholder: t('addShift.location.placeholder')}}
                                                         className="width-100p block"/>

                                                {(this.state.errors && this.state.errors.location) ? (
                                                    <span className="help-block">
                                                        {t('addShift.location.error.' + this.state.errors.location)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.comment) ? ' has-error' : '')}>
                                                <label>{t('addShift.comment.label')}</label>
                                                <textarea className="form-control" name="comment" value={this.state.comment} onChange={(e) => this.setState({comment: e.target.value})}/>

                                                {(this.state.errors && this.state.errors.comment) ? (
                                                    <span className="help-block">
                                                        {t('addShift.location.error.' + this.state.errors.comment)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-default" type="button" disabled={this.state.loading} onClick={this.props.cancel}>
                                        {t('default.cancel')}
                                    </button>
                                    <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                        {t('default.save')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {}
};

const mapDispatchToProps = dispatch => {
    return {
        cancel: () => {
            dispatch(appDialogAddShiftClose())
        },
        getSchedule: () => {
            dispatch(getSchedule())
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(translate()(AddShiftDialog));
